import script from "./ResRecordProve.vue?vue&type=script&setup=true&lang=js"
export * from "./ResRecordProve.vue?vue&type=script&setup=true&lang=js"

import "./ResRecordProve.vue?vue&type=style&index=0&id=b18a92e8&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18a92e8"]])

export default __exports__